import { AspectRatio, Flex, Heading, Stack } from '@chakra-ui/react'
import { toCmsMediaFileUrl } from '@twlvxtwlv/cms'
import Image from 'next/image'
import { Content } from '../../../../../shared/content'

interface TokenContentProps {
  description?: string
  headline?: string
  imageAlt?: string
  imageUrl?: string
  subHeadline?: string
}

export function TokenContent({
  description,
  headline,
  imageAlt,
  imageUrl,
  subHeadline,
}: TokenContentProps) {
  const url = toCmsMediaFileUrl(imageUrl)

  return (
    <Flex
      direction={{ base: 'column-reverse', xl: 'row' }}
      w="full"
      gap={4}
      alignItems="flex-start"
    >
      <Stack spacing={0} gap={4} flex={1}>
        <Stack w="full" spacing={0}>
          {subHeadline ? (
            <Heading as="h3" fontSize="xs" fontWeight="bold" color="txtDarkGray">
              {subHeadline}
            </Heading>
          ) : null}
          <Heading as="h2" textTransform="uppercase" fontSize="xl">
            {headline}
          </Heading>
        </Stack>

        {description ? <Content content={description} /> : null}
      </Stack>

      {url ? (
        <AspectRatio maxW="400px" ratio={1} flex={1}>
          <Image
            src={url}
            alt={imageAlt ?? 'image'}
            width={400}
            height={400}
            style={{
              objectFit: 'contain',
            }}
          />
        </AspectRatio>
      ) : null}
    </Flex>
  )
}
